import { IS_TELEGRAM } from "./utils/runtime";

/**
 * Регистрируем Service Worker для PWA — но только в браузерной версии
 * и только в production-сборке. В Telegram Mini App SW не нужен: TG
 * сам управляет lifecycle страницы, а его наличие может мешать
 * hot-обновлениям mini app'а.
 *
 * SW живёт в `/service-worker.js` (CRA не эжектит его автоматически,
 * потому что мы не используем workbox-плагин; вместо этого простая
 * ручная регистрация — так проще контролировать поведение).
 */
export function registerPwa() {
  // Локальный dev-режим SW отключён — не путаемся с горячей
  // перезагрузкой и не кешируем dev-сборку.
  if (process.env.NODE_ENV !== "production") return;
  if (IS_TELEGRAM) return;
  if (typeof navigator === "undefined" || !("serviceWorker" in navigator)) {
    return;
  }

  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/service-worker.js", { scope: "/" })
      .then((reg) => {
        // Автообновление: если появилась новая версия SW — активируем
        // её после следующего reload'а. Пользователю ничего показывать
        // не надо, обновление подхватится тихо.
        reg.onupdatefound = () => {
          const installing = reg.installing;
          if (!installing) return;
          installing.onstatechange = () => {
            if (
              installing.state === "installed" &&
              navigator.serviceWorker.controller
            ) {
              // Есть новая версия и есть активная — на следующем открытии
              // страницы CRA сам подтянет свежую сборку из кеша.
              console.info("[pwa] update ready");
            }
          };
        };
      })
      .catch((err) => {
        console.warn("[pwa] service worker registration failed", err);
      });
  });
}
